// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../../Api";
import ResponseChecker from "../../Middlewares/ResponseChecker";
import { defaultMessages } from "../../enums/responseMessages.js";

import Endpoints from "../../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## MobileApp.CustomerUsers Get
/**
 *
 * @param {{params: object, query: { paymentMethodId: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(
    Endpoints.MobileApp.CustomerUsers.GetAll(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## MobileApp.CustomerUsers Create
/**
 *
 * @param {{ paymentMethodId: string, MobileApp.CustomerUsersRate: number }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(
    Endpoints.MobileApp.CustomerUsers.Create(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.CustomerUsers Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(
    Endpoints.MobileApp.CustomerUsers.GetById(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.CustomerUsers Update
/**
 *
 * @param {{ paymentMethodId: string, MobileApp.CustomerUsersRate: number, isActive: boolean }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.MobileApp.CustomerUsers.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.CustomerUsers Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(
    Endpoints.MobileApp.CustomerUsers.Delete(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

/**
 *
 * @param {{ username: string, password: string, deviceToken: string, customerId: string }} form
 
 * @returns
 */
export const Login = async (form) => {
  const response = await $api.post(
    Endpoints.MobileApp.CustomerUsers.Login({}),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  Login,
};
